import { render, staticRenderFns } from "./AllOtherIncomeEntries.vue?vue&type=template&id=74bf2274"
import script from "./AllOtherIncomeEntries.vue?vue&type=script&lang=js"
export * from "./AllOtherIncomeEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports